import React, { FC, ImgHTMLAttributes, useLayoutEffect, useRef } from "react";

interface IImageProps {
  src?: string;
  src2x?: string;
  src3x?: string;
  radius?: number | string;
  onLoaded?: (isLoaded: boolean) => void;
}

const StaticImageComponent: FC<
  IImageProps & ImgHTMLAttributes<HTMLImageElement>
> = ({
  alt,
  width,
  height,
  radius,
  className,
  style,
  srcSet,
  src,
  src2x,
  src3x,
  decoding = "async",
  onLoaded,
  ...otherProps
}) => {
  const ref = useRef<HTMLImageElement>(null);

  useLayoutEffect(() => {
    const alreadyLoaded =
      !!ref.current?.complete && ref.current.naturalWidth > 0;
    onLoaded?.(alreadyLoaded);
  }, [src, src2x, src3x, onLoaded]);

  const handleLoad = () => {
    onLoaded?.(true);
  };

  return (
    <img
      {...otherProps}
      ref={ref}
      className={className}
      data-src={src2x ? `${src} 1x, ${src2x} 2x, ${src3x} 3x` : src}
      srcSet={src2x ? `${src} 1x, ${src2x} 2x, ${src3x} 3x` : src}
      // sizes="(max-width: 600px) 100px, (max-width: 1200px) 200px, 300px"
      style={{ ...style, borderRadius: radius }}
      src={src}
      alt={alt}
      width={width}
      height={height}
      decoding={decoding}
      onLoad={handleLoad}
    />
  );
};

export const StaticImage = React.memo(StaticImageComponent);
